import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

import {
  getDocusignTemplateUrl,
} from "@/api/docusign/thunks";
import { RootState, SigningState } from "@/types/store";

const initialState: SigningState = {
  loading: false,
  signUrl: "",
  error: null,
  signingStatusLoading: false,
  signingStatusError: null,
  documents: [],
};

const SigningSlice = createSlice({
  name: "SigningSlice",
  initialState,
  reducers: {
    resetSigningState: (state) => {
      state.loading = false;
      state.signUrl = "";
      state.error = null;
      state.signingStatusLoading = false;
      state.signingStatusError = null;
      state.documents = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Dynamic template URL fetching
      .addCase(getDocusignTemplateUrl.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDocusignTemplateUrl.fulfilled, (state, action) => {
        state.loading = false;
        state.signUrl = action.payload;
        state.error = null;
      })
      .addCase(getDocusignTemplateUrl.rejected, (state, action) => {
        state.loading = false;
        state.signUrl = "";
        state.error = action.payload ? String(action.payload) : "Unknown error";
      });
  },
});

export const { resetSigningState } = SigningSlice.actions;

export default SigningSlice.reducer;

export const useSigningData = () => {
  const {
    loading,
    signUrl,
    error,
    signingStatusLoading,
    signingStatusError,
    documents,
  } = useSelector((state: RootState) => state.Signing);

  return {
    loading,
    signUrl,
    error,
    signingStatusLoading,
    signingStatusError,
    documents,
  };
};
